function fixNaN(val) {
  if (isNaN(val) || !val) {
    return 0;
  } else {
    return val;
  }
}

class BroadcastService {

    constructor() {
        // Viewer min and max values for normalization
        this.minViewerCount = 0;
        this.maxViewerCount = 0;

        // Viewer min and max values for normalization
        this.minTicketCount = 0;
        this.maxTicketCount = 0;

        // Rough returned value ranges included
        this.weight = {
            ending: 15,         // 0-100
            active: 45,         // 0-100 (allow floats)
            tickets: 15,        // 0-100
            status: 75,         // 0-100
            support: 100,       // 0-100
            accessibility: 15,  // -25-50
            source: 88,         // 0-100
            diagnostics: 25,    // 0-100
        };
    }

    // Magical weighting for sort
    powerSort(broadcasts) {
        let formatted = {};
        let score = 0;

        // Get the min/max viewer count
        this.minViewerCount = Math.min.apply(Math,broadcasts.map((row) => row.total_active_viewer_count ));
        this.maxViewerCount = Math.max.apply(Math,broadcasts.map((row) => row.total_active_viewer_count ));

        // Get the min/max ticket count
        this.minTicketCount = Math.min.apply(Math,broadcasts.map((row) => row.sold_ticket_count ));
        this.maxTicketCount = Math.max.apply(Math,broadcasts.map((row) => row.sold_ticket_count ));
        
        broadcasts.map((row) => {
            formatted = row;

            score = 0;
            score += this.weight.ending * fixNaN(this.scoreTime(row.stops_at, row.total_active_viewer_count));
            score += this.weight.active * fixNaN(this.scoreViewerCount(row.total_active_viewer_count));
            score += this.weight.tickets * fixNaN(this.scoreTicketCount(row.sold_ticket_count));
            score += this.weight.status * fixNaN(this.scoreStatus(row.status));
            score += this.weight.support * fixNaN(this.scoreSupportPlan(row.account_support_plan));
            score += this.weight.accessibility * fixNaN(this.scoreAccessibility(row.is_private, row.is_ticketed, row.free_variant));
            score += this.weight.source * fixNaN(this.scoreSource(row.stream_source));
            score += this.weight.diagnostics * fixNaN(this.scoreDiagnostics(row.stream_diagnostics));
            
            formatted.score = parseInt(score, 10);

            return formatted;
        });
        return broadcasts;
    }

    scoreTime(stopsAt, viewers) {
        // We only care if you're within the 15-minute window of a broadcast ending
        // and there are people currently viewing
        const secondsLeft = moment(stopsAt).diff(moment(), 'seconds');
        const doesTimeMatter = secondsLeft > 0 && secondsLeft <= (15*60) ? true : false;
        return doesTimeMatter ? (1/secondsLeft)*100 : 0;
    }

    scoreViewerCount(viewers) {
        const normalized = ((viewers - this.minViewerCount) / (this.maxViewerCount - this.minViewerCount))*100;
        return normalized;
    }

    scoreTicketCount(tickets) {
        const normalized = !this.maxTicketCount ? 0 : parseInt(((tickets - this.minTicketCount) / (this.maxTicketCount - this.minTicketCount))*100);
        return normalized;
    }

    scoreStatus(status) {
        // If a broadcast is live, that's good and somewhat important!
        if (status === 'live') {
            return 15;
        }
        // Pay more careful attention to broadcasts that are stalled.
        if (/stalled/i.test(status) && !/catching_up/i.test(status)) {
            return 100;
        }
        // Still on high alert, but probably on track.
        if (/catching_up/i.test(status)) {
            return 65;
        }
        // All is well, but it's spinning up
        if (/preparing/i.test(status)) {
            return 20;
        }
        return 0;

        // TODO: Consider % of prepartion?
        // TODO: Consider special cases -- e.g. no video?
    }

    scoreDiagnostics(d) {
        let status = (d||{}).status;
        if (status === 'OK') {
            return 0;
        } else if (status === 'Warning') {
            return 50;
        } else if (status === 'Critical') {
            return 100;
        } else {
            return 10; //is it unknown for some strange reason?
        }
    }

    scoreSupportPlan(plan) {
        // Embiggenification of higher priority support plan customers
        if (plan === 'reduced') {
            return -100;
        }
        if (plan === 'priority') {
            return 100;
        }
        return 0;
    }

    scoreAccessibility(isPrivate, isTicketed, freeQuality) {
        let accessibility = 0;
        // Private events are less exposed
        if (isPrivate) {
            accessibility += -15;
        }
        // Ticketed events means people spent moola!
        if (isTicketed) {
            accessibility += 50;
        }
        // Score lower if we're giving away the highest quality broadcast
        if (freeQuality === "low") {
            accessibility += 25;
        }
        return accessibility;
    }

    scoreSource(streamSource) {
        switch(streamSource) {
            case 'boxcaster-pro':
                // BoxCaster Pros are elevated for now.
                return 100;
                break;
        }
        // Everybody else... meh...
        return 0;
    }

}

angular.module('app.services').service('BroadcastService', BroadcastService);


// WEBPACK FOOTER //
// ./services/broadcast_service.js